.popover-menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 75px !important;
  padding: 5px !important;
}

.anchor-disabled {
  cursor: auto !important;
}

:global(.popover-menu__with-tail .MuiList-root:before) {
  content: '';
  display: block;
  position: absolute;
  right: 50%;
  width: 10px;
  height: 10px;
  background-color: white;
  z-index: -10;
  box-shadow: rgba(0, 0, 0, 0.08) -1px -1px 0 0px !important;
}

:global(.popover-menu__with-tail--up .MuiList-root:before) {
  top: 0;
  transform: translateY(-50%) translateX(50%) rotate(45deg);
}

:global(.popover-menu__with-tail--down .MuiList-root:before) {
  bottom: 0;
  transform: translateY(50%) translateX(50%) rotate(225deg);
}

:global(.popover-menu__with-tail > .MuiPaper-root) {
  overflow: visible !important;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.08)) !important;
}

:global(.popover-menu__with-tail > .MuiPaper-root > .MuiList-root) {
  overflow: visible;
}
